module.exports = __webpack_public_path__ + "static/preset-image-hero-b47f1b854a8c940ee00fe834717cc55f.png";